var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",style:(("\n    overflow-y:auto;\n    position: relative;\n    height:calc(100vh - " + _vm.topSpacing + "px);")),attrs:{"id":_vm.scrollContainerId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }